import {connect} from "react-redux";
import React, {Component} from "react";
import queryString from "query-string";
import * as actions from '../../store/actions';
import {Redirect} from "react-router-dom";
import {Loader} from "react-overlay-loader";

class SamlLogIn extends Component {
    state = {
        sessionId: null,
        email: null,
    }

    componentWillMount() {
        let qs = queryString.parse(this.props.location.search);
        let sessionId = qs.sessionId;
        let email = qs.email;
        this.setState({sessionId: sessionId, email: email})
        this.props.onSamlLogin(email, sessionId);
    }

    render() {
        let redirect = null;
        if (this.props.isAuthenticated && !this.props.gcpOnly) {
            redirect = <Redirect to={{pathname: '/dashboard'}}/>
        } else if (this.props.isAuthenticated && this.props.gcpOnly) {
            redirect = <Redirect to={{pathname: '/gcpDashboard'}}/>
        } else if (this.props.isAuthenticated) {
            redirect = <Redirect to={{pathname: '/dashboard'}}/>
        } else if (this.props.error) {
            redirect = <Redirect to={{pathname: '/login'}}/>
        }
        return (
            <div>
                {redirect}
                <Loader fullPage={true} loading={this.props.loading}/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.login.loading,
        error: state.login.error,
        isAuthenticated: state.login.token != null,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSamlLogin: (email, sessionId) => dispatch(actions.samlLogin(email, sessionId))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SamlLogIn)